import { z } from 'zod';

export const organizationFormSchema = z.object({
  name: z.string().nonempty('Name is required')
});

export type OrganizationFormValues = z.infer<typeof organizationFormSchema>;
